import { render, staticRenderFns } from "./SpecializationAddEditModal.vue?vue&type=template&id=ad69b5cc"
import script from "./SpecializationAddEditModal.vue?vue&type=script&lang=js"
export * from "./SpecializationAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports